import { DoorbellConfiguration } from 'src/lib/doorbell/doorbell';
import { ApplicationInsightsConfiguration } from 'src/lib/tcs-app-insights/app-insights-initializer.service';
import { NewRelicConfiguration } from 'src/lib/tcs-new-relic/new-relic-initializer.service';
import { AuthenticationConfig } from './shared/authentication/authentication-api/authentication.config';
import { TcsOktaConfig } from './shared/okta/tcs-okta.config';
import { PubnubConfig } from './shared/pubnub/pubnub-config';
import { LoggingConfiguration } from './shared/tcs-logging/logging.config';
export interface TcsClientConfig {
  graphqlUri: string;
  opsUri: string;
  orgUri: string;
}
export interface TcsConfiguration {
  tcs: TcsClientConfig;
  authentication: AuthenticationConfig;
  logging: LoggingConfiguration;
  pubnub: PubnubConfig;
  applicationInsights: ApplicationInsightsConfiguration;
  doorbell: DoorbellConfiguration;
  clientSync: {
    forceRefreshOnHeartbeatSilence: boolean;
    heartbeatSilenceThresholdInSeconds: number;
  };
  identity: {
    activeDirectorySyncDefault: boolean;
    activeDirectorySyncOptionEnabled: boolean;
  };
  operations: {
    positionAlertTimeoutInMinutes: number;
  };
  okta: TcsOktaConfig;
  features: TCSFeaturesConfiguration;
  newRelic: NewRelicConfiguration;
}
export interface TCSFeaturesConfiguration {
  qaQuestionnaireEnabled: boolean;
  transferCenterEnabled: boolean;
  cadTimerEnabled: boolean;
  webOrderAlertLogEnabled: boolean;
  opsReaderEnabled: boolean;
  deleteCardProductionPromptInNonProdEnabled?: boolean;
}
export interface ClientContext {
  environment: 'local' | 'dev' | 'qa' | 'trn' | 'prod';
  configuration: TcsConfiguration;
}

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const configuration_DEPRECATED: TcsConfiguration = clientContext.configuration;
